module.exports = __webpack_public_path__ + "static/media/uae.ebaa57cc.svg";